import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Menu, NavService } from 'src/app/shared/services/nav.service';

@Component({
  selector: 'app-carousel-buttons',
  templateUrl: './carousel-buttons.component.html',
  styleUrls: ['./carousel-buttons.component.scss'],
})
export class CarouselButtonsComponent implements OnInit {
  public items: Menu[] = [];

  constructor(private navServices: NavService, private router: Router) {}

  ngOnInit(): void {
    this.navServices.items.subscribe((itens: Menu[]) => {
      itens.forEach((item) => {
        if (item.type == 'link') this.items.push(item);
      });
    });
  }

  goToPage(item: Menu): void {
    if (item.path) {
      this.router.navigateByUrl(item.path);
    }
  }
}
